import type { IxmUserauthV1ProgramKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PROGRAM_BASE_PATH = getResolvedPath('/program');

export const getProgramPath: EntityPathBuilder<IxmUserauthV1ProgramKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PROGRAM_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.programId) {
        return undefined;
      }

      return getResolvedPath(`${PROGRAM_BASE_PATH}/$programId`, context.keys);
    }
  }
};

export function getProgramDetailPath(programId: string | undefined) {
  if (!programId) {
    return undefined;
  }

  return getProgramPath({ kind: 'detail', keys: { programId } });
}

export function getProgramConfigurationPath(programId: string | undefined) {
  return getResolvedPath('/program/$programId/configuration', { programId });
}

export function getProgramBrandingConfigurationPath(programId: string | undefined) {
  return getResolvedPath('/program/$programId/branding', { programId });
}
